<!-- <div class="min-h-screen font-['Montserrat',sans-serif] kga-design-page">
  <div class="kga-app-shell">
    @if (showNavbar) {
    <app-navbar></app-navbar>
    }

    <div class="kga-shell-grid" [class.kga-shell-grid-collapsed]="isCollapsed"
      [class.kga-shell-grid--no-navbar]="!showNavbar">
      <app-sidebar (collapsedChange)="isCollapsed = $event"></app-sidebar>

      <main class="kga-main-panel transition-all duration-300">
        <div class="kga-page">
          <router-outlet></router-outlet>
        </div>
      </main>
    </div>
  </div>
</div> -->

<div class="min-h-screen font-['Montserrat',sans-serif] kga-design-page">
  <button class="mobile-menu-btn" (click)="mobileSidebarOpen = !mobileSidebarOpen">
    ☰
  </button>

  <div class="kga-app-shell">

    @if (showNavbar) {
    <app-navbar></app-navbar>
    }

    <div class="kga-shell-grid" [class.kga-shell-grid-collapsed]="isCollapsed"
      [class.kga-shell-grid--no-navbar]="!showNavbar">
      <div class="mobile-overlay" *ngIf="mobileSidebarOpen" (click)="mobileSidebarOpen = false">
      </div>

      <div class="mobile-sidebar" [class.mobile-sidebar-open]="mobileSidebarOpen">

        <app-sidebar (collapsedChange)="isCollapsed = $event">
        </app-sidebar>

      </div>

      <main class="kga-main-panel transition-all duration-300">
        <div class="kga-page">
          <router-outlet></router-outlet>
        </div>
      </main>

    </div>
  </div>
</div>